import {
  Accordion,
  Avatar,
  Badge,
  Box,
  Button,
  Modal,
  SimpleGrid,
  Switch,
  Text,
  Flex,
  Textarea,
} from "@mantine/core";
import useStyles from "./../MAR/modalStyle";
import CloseCircle from "../CloseCircle";
import moment from "moment";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getSinglePatients } from "../../services/patient";
import { decrypt } from "../../utils";
import { IconChevronDown } from "@tabler/icons-react";
import { useMediaQuery } from "@mantine/hooks";
import { planTypeLabels } from "../MAR/ClientSupportPlans";
import { DateInput } from "@mantine/dates";
import UpdateAndViewEssentialSupport from "../UpdateAndViewEssentialSupport";
import { FiMinus, FiPlus } from "react-icons/fi";

const ViewCarePlanModal = ({
  opened,
  onclose,
  data,
  setShowCarePlanDetails,
  setRowData,
}) => {
  const { classes } = useStyles();
  const id = data?.client?._id;
  const clientId = id?.slice(-6);
  const [clientDetails, setClientDetails] = useState(null);
  const { state } = useLocation();
  const [essentialSupportData, setEssentialSupportData] = useState([]);

  const getData = async () => {
    let res;
    if (state?.notificationDoc) {
      res = await getSinglePatients(state?.notificationDoc?.client?.id);
    } else if (state.planDoc) {
      res = await getSinglePatients(state?.planDoc?.client?.id);
    } else {
      res = await getSinglePatients(
        typeof state === "string" ? state : state?.client?.client?.id
      );
    }
    setClientDetails(res);
  };

  useEffect(() => {
    getData();
  }, [state]);

  const isMobileScreen = useMediaQuery("(max-width: 800px)");

  const handleClose = () => {
    onclose();
    setShowCarePlanDetails(false);
    setRowData(null);
  };

  const labels = planTypeLabels[data?.planType?.planId] || planTypeLabels["1"];

  return (
    <>
      <div style={{ overflowX: "auto" }}>
        <div style={{ minWidth: "1000px" }}>
          <Modal
            className={classes.medicationModal}
            opened={opened}
            onClose={handleClose}
            shadow="md"
            overlayProps={{ blur: 3 }}
            radius={"lg"}
            zIndex={1000}
            centered
            size={1200}
          >
            <CloseCircle onclose={handleClose} />
            <Box className={classes.header}>
              <Text variant="text" fw={600} size={24}>
                {data?.planType?.name || "Care Plan"}
              </Text>
            </Box>
            <Box className={classes.viewModalContent}>
              <Box className={classes.headerContent}>
                <Box className={classes.userDetails}>
                  <Box className={classes.userImg}>
                    <Avatar
                      shape="square"
                      radius="xl"
                      size={"xl"}
                      src={
                        clientDetails?.imageurl
                          ? decrypt(clientDetails?.imageurl)
                          : "/assets/images/personal2.png"
                      }
                    />
                    <Box className={classes.userInfo}>
                      <Text variant="text" fw={600} size={24}>
                        {data?.client?.name}
                      </Text>
                      <Text variant="text" fw={300}>
                        {clientId}
                      </Text>
                    </Box>
                  </Box>
                  <Box>
                    <SimpleGrid cols={3}>
                      <Text mt={5}>
                        <strong>Start Date:</strong>{" "}
                        {moment(data?.startDate).format("DD/MM/YYYY")}
                      </Text>
                      <div className={classes.type}>
                        <Text variant="text" fw={600}>
                          {data?.planType?.name}
                        </Text>
                        <Text variant="text" className={classes.date}>
                          {moment(data?.startDate).format("DD/MM/YYYY")} -{" "}
                          {moment(data?.endDate).format("DD/MM/YYYY")}
                        </Text>
                      </div>
                    </SimpleGrid>
                  </Box>
                </Box>
                {data?.isActive !== false && (
                  <Box className={classes.editBTN}>
                    <Button
                      onClick={() => onclose() || setShowCarePlanDetails(true)}
                      color="gray"
                      variant="transparent"
                      type="link"
                    >
                      Edit
                    </Button>
                  </Box>
                )}
              </Box>
              <Box className={classes.body}>
                {data?.outcomes?.length > 0 ? (
                  data?.outcomes?.map((out, index) => (
                    <>
                      <Accordion
                        key={out.id}
                        chevron={<IconChevronDown size={30} color="var(--app-primary)" />}
                        chevronPosition="right"
                        chevronSize={30}
                        styles={{
                          chevron: {
                            transition: "transform 200ms ease",
                            "&[data-active]": {
                              transform: "rotate(180deg)",
                            },
                          },
                        }}
                      >
                        <Accordion.Item value={"planType"}>
                          <Accordion.Control>
                            <SimpleGrid cols={3}>
                              <Box className={classes.accordionHeader}>
                                <Badge color="yellow" size="xl" circle>
                                  {out?.outcomeNumber}
                                </Badge>
                                <Text variant="text">
                                  {labels?.addNewButtonLabel}
                                </Text>
                              </Box>
                              <Box className={classes.accordionHeader}>
                                <Text variant="text" fw={600}>
                                  Title:
                                </Text>{" "}
                                <Text className={classes.accordionTitle}>
                                  {out?.outcomeTitle}
                                </Text>
                              </Box>
                              <Box className={classes.accordionHeader}>
                                <Text variant="text" fw={600}>
                                  Category:
                                </Text>{" "}
                                <Text className={classes.accordionTitle}>
                                  {out?.outcomeCategory}
                                </Text>
                              </Box>
                            </SimpleGrid>
                          </Accordion.Control>
                          <Accordion.Panel
                            colapsed
                            className={classes.accordionPanel}
                          >
                            {data?.planType?.planId === "3" && (
                              <>
                                <Box mb={20}>
                                  <Textarea
                                    id="add-care-note"
                                    autosize={true}
                                    minRows={4}
                                    maxRows={10}
                                    className={classes.textArea}
                                    size="sm"
                                    variant="filled"
                                    label="Desired Outcome"
                                    placeholder="Enter desired outcome"
                                    disabled={true}
                                    value={out?.desiredOutcome}
                                  />
                                </Box>

                                <Box className={classes.keyStepsBox}>
                                  <Box className={classes.keyStepsText}>
                                    <Text>
                                      Key steps and services to get there
                                    </Text>
                                  </Box>
                                  {out?.keySteps?.map((step, stepIndex) => (
                                    <Flex
                                      w={"100%"}
                                      key={step.id}
                                      gap={10}
                                      align="center"
                                      justifyContent="center"
                                      // mt="xs"
                                      p={10}
                                    >
                                      <Text>{stepIndex + 1}</Text>
                                      <Textarea
                                        value={step.text}
                                        autosize
                                        w={"100%"}
                                        size="sm"
                                        disabled={true}
                                        // onChange={(e) =>
                                        //   handleKeyStepChange(
                                        //     out.id,
                                        //     step.id,
                                        //     e.target.value
                                        //   )
                                        // }
                                        placeholder="Enter key step"
                                      />
                                      {out?.keySteps?.length > 1 && (
                                        <Button
                                          size="xs"
                                          variant="default"
                                          w={40}
                                          h={40}
                                          style={{ borderRadius: "50%" }}
                                          p={0}
                                          // onClick={() =>
                                          //   handleRemoveKeyStep(out.id, step.id)
                                          // }
                                        >
                                          <FiMinus size={20} />
                                        </Button>
                                      )}
                                      {stepIndex ===
                                        out?.keySteps?.length - 1 && (
                                        <Button
                                          variant="default"
                                          size="xs"
                                          w={40}
                                          h={40}
                                          style={{ borderRadius: "50%" }}
                                          p={0}
                                          // onClick={() => handleAddKeyStep(out.id)}
                                        >
                                          <FiPlus size={20} />
                                        </Button>
                                      )}
                                    </Flex>
                                  ))}
                                </Box>
                              </>
                            )}
                            <Text variant="text" fw={600} fz={20} mb={15}>
                              {`${labels?.typeTitle} Details`}
                            </Text>
                            <Box className={classes.supportDetailsContent}>
                              {out.activities?.length > 0 &&
                                out?.activities?.map((act, actIndex) => (
                                  <>
                                    <Box
                                      className={classes.supportActivityDetails}
                                    >
                                      <Text
                                        variant="text"
                                        fw={600}
                                        className={classes.activityNumber}
                                      >
                                        {act?.activityNumber}
                                      </Text>
                                      <Box className={classes.activityFields}>
                                        <Box className={classes.activityInputs}>
                                          <Box className={classes.textInputBox}>
                                            <Text className="label">
                                              {labels?.supportActivityLabel}
                                            </Text>
                                            <Box
                                              className={classes.supportBorder}
                                            >
                                              <Text
                                                variant="text"
                                                className={
                                                  classes.supportActivityText
                                                }
                                              >
                                                {act?.supportActivity}
                                              </Text>
                                            </Box>
                                          </Box>
                                          <Box className={classes.textInputBox}>
                                            <Text className="label">
                                              {labels?.supportInstructionsLabel}
                                            </Text>
                                            <Box
                                              className={classes.supportBorder}
                                            >
                                              <Text
                                                variant="text"
                                                className={
                                                  classes.supportActivityText
                                                }
                                              >
                                                {act?.supportInstructions}
                                              </Text>
                                            </Box>
                                          </Box>
                                        </Box>
                                        {data?.planType?.planId === "3" && (
                                          <Box
                                            className={classes.activityInputs}
                                          >
                                            <Box
                                              className={classes.textInputBox}
                                            >
                                              <Text className="label">
                                                I No Longer Need This Support
                                                When
                                              </Text>
                                              <Box
                                                className={
                                                  classes.supportBorder
                                                }
                                              >
                                                <Text
                                                  variant="text"
                                                  className={
                                                    classes.supportActivityText
                                                  }
                                                >
                                                  {
                                                    act?.iNoLongerNeedThisSupportWhen
                                                  }
                                                </Text>
                                              </Box>
                                            </Box>
                                            <Box
                                              className={classes.textInputBox}
                                            >
                                              <Text className="label">
                                                What to Record
                                              </Text>
                                              <Box
                                                className={
                                                  classes.supportBorder
                                                }
                                              >
                                                <Text
                                                  variant="text"
                                                  className={
                                                    classes.supportActivityText
                                                  }
                                                >
                                                  {act?.whatToRecord}
                                                </Text>
                                              </Box>
                                            </Box>
                                          </Box>
                                        )}
                                      </Box>
                                    </Box>
                                    <Box
                                      className={classes.supportDetailButtons}
                                    >
                                      <Box
                                        className={
                                          classes.supportDetailRightButtons
                                        }
                                      >
                                        <Text variant="text" fw={500}>
                                          Skill-Building
                                        </Text>
                                        <Switch
                                          checked={act?.skillBuilding === "yes"}
                                          color="yellow"
                                          size="md"
                                          title="Skill-Building"
                                        />
                                      </Box>
                                      <Box
                                        className={
                                          classes.supportDetailRightButtons
                                        }
                                      >
                                        <Text variant="text" fw={500}>
                                          Intensive In-Home
                                        </Text>
                                        <Switch
                                          checked={
                                            act?.intensiveInHome === "yes"
                                          }
                                          color="yellow"
                                          size="md"
                                          title="Intensive In-Home"
                                        />
                                      </Box>
                                    </Box>
                                    {data?.planType?.planId === "3" && (
                                      <Box
                                        mx={30}
                                        style={{
                                          width: "100%",
                                          marginTop: "15px",
                                        }}
                                      >
                                        {act?.skillBuilding === "yes" && (
                                          <Textarea
                                            className={classes.textInputBox}
                                            placeholder="Skill description"
                                            value={act?.skillBuildingText}
                                            readOnly={true}
                                            autosize
                                            minRows={2}
                                          />
                                        )}
                                      </Box>
                                    )}
                                  </>
                                ))}
                            </Box>
                            <SimpleGrid
                              cols={isMobileScreen ? 1 : 3}
                              // className={classes.mwd}
                              sx={{
                                paddingBottom: 30,
                                display: "flex",
                                flexDirection: "column",
                                gap: 0,
                              }}
                            >
                              <Box className={classes.oftenAndDateParent}>
                                <div>
                                  <Text variant="text">
                                    How often you do this activity.
                                  </Text>
                                  <Box className={classes.howOften}>
                                    <Text
                                      variant="text"
                                      title="How often you do this activity."
                                      className={classes.supportActivityText}
                                    >
                                      {out?.howOften}
                                    </Text>
                                  </Box>
                                </div>
                                {/* ----- By When ----- */}
                                {data?.planType?.planId === "3" && (
                                  <DateInput
                                    disabled={true}
                                    id="add-plan-end-date"
                                    size="sm"
                                    clearable
                                    label="By When"
                                    variant="unstyled"
                                    minDate={new Date()}
                                    placeholder={"mm/dd/yyyy"}
                                    withAsterisk
                                    rightSection={
                                      <img
                                        style={{ width: "30px" }}
                                        src={"/assets/images/calendar-icon.png"}
                                        alt="Icon"
                                      />
                                    }
                                    className={classes.dateStyle}
                                    value={moment(out.byWhen).toDate()}
                                  />
                                )}
                              </Box>
                            </SimpleGrid>
                            {data?.planType?.planId != "3" && (
                              <SimpleGrid
                                cols={isMobileScreen ? 2 : 2}
                                className={classes.mwd}
                                sx={{
                                  paddingBottom: 30,
                                }}
                              >
                                <Box className={classes.textInputBox}>
                                  <Text className="label">
                                    {labels?.noLongerNeedLabel}
                                  </Text>
                                  <Box
                                    className={classes.supportBorder}
                                    style={{ width: "100%" }}
                                  >
                                    <Text
                                      variant="text"
                                      className={classes.supportActivityText}
                                    >
                                      {out?.iNoLongerNeedThisOutcome}
                                    </Text>
                                  </Box>
                                </Box>
                                <Box className={classes.textInputBox}>
                                  <Text className="label">
                                    Additional Information
                                  </Text>
                                  <Box
                                    className={classes.supportBorder}
                                    style={{ width: "100%" }}
                                  >
                                    <Text
                                      variant="text"
                                      title="Additional Information"
                                      className={classes.supportActivityText}
                                    >
                                      {out?.additionalInformation}
                                    </Text>
                                  </Box>
                                </Box>
                              </SimpleGrid>
                            )}
                          </Accordion.Panel>
                        </Accordion.Item>
                      </Accordion>
                    </>
                  ))
                ) : (
                  <Text variant="text">No Outcome</Text>
                )}
                {/* ----- Show remaining data in new file to keep code readablity & maintainability ----- */}
                <UpdateAndViewEssentialSupport
                  setSelectedFacility={""}
                  setSelected={""}
                  view={true}
                  data={data}
                  carePlanType={""}
                  handleTableBoxClick={""}
                  essentialSupportData={essentialSupportData}
                  setEssentialSupportData={setEssentialSupportData}
                />
              </Box>
            </Box>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default ViewCarePlanModal;
